// extracted by mini-css-extract-plugin
export var resizer = "_d1-0";